module.exports = __webpack_public_path__ + "static/Health-coach-logo@3x-1a41144a601e815ac75364af2220006b.png";